import { Asset, LoginAccount, Person, Referral, ReferralRespondBack, Report } from "types";
import apiClient from "../lib/apiClients";

export const fetchAssetsList = async () => {
  const response = await apiClient.get<Asset[]>(
    "asset_recovery/assets/"
  );
  return response.data;
};

export const fetchReferralsList = async () => {
  const response = await apiClient.get<Referral[]>(
    "asset_recovery/referrals/"
  );
  return response.data;
};

export const fetchReferralsByAdminUnit = async (adminUnitId: string) => {
  const response = await apiClient.get<Referral[]>(
    `asset_recovery/referrals/filter-by-admin-unit/?admin_unit_id=${adminUnitId}`
  );
  return response.data;
};
export const fetchAssetReceptionMethodsList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/asset-reception-methods/"
  );
  return response.data;
};

export const createAssetReferral = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/referrals/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const addAsserSuspectsMappingToReferral = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/count-suspects/`,
    data,
  );
  return response.data;
};

export const addAssetReferralProhbitionRequest = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/prohabition_request/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const updateAssetReferralProhibitionRequest = async (prohibitionId: string, data: any) => {
  const response = await apiClient.patch(
    `asset_recovery/prohabition_request/${prohibitionId}/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const getSuspectAssetMappingByReferralId = async (referralId: string) => {
  const response = await apiClient.get(
    `asset_recovery/count-suspects/by-referral/?referral_id=${referralId}`,
  ); return response.data;
}

export const fetchSuspectsCountForReferral = async (referralId: string) => {
  const response = await apiClient.get(
    `asset_recovery/referrals/${referralId}/count-suspects/`
  );
  return response.data;
};

export const createAssetReceptionMethod = async (data: { name: string }) => {
  const response = await apiClient.post(
    "base_data/asset-reception-methods/",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const fetchAssetOwnerRelationshipsList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/asset-owner-relationships/"
  );
  return response.data;
};

export const fetchAssetCrimeCategoriesList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/asset-crime-categories/"
  );
  return response.data;
};
export const fetchCrimeCategoriesList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/crime-categories/"
  );
  return response.data;
};

export const fetchAssetCaseConditionsList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/asset-case-conditions/"
  );
  return response.data;
};

export const fetchAssetVictimTypesList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/asset-victim-types/"
  );
  return response.data;
};

export const fetchAssetNotInCustodyReasonsList = async () => {
  const response = await apiClient.get<{ uu_id: string, name: string }[]>(
    "base_data/asset-not-in-custody-reasons/"
  );
  return response.data;
};

export const fetchCourtDecisionsList = async () => {
  const response = await apiClient.get<{ uu_id: string, court_decision: string }[]>(
    "base_data/court_decision/"
  );
  return response.data;
};

export const createAssetVictim = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/victims/",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const createAssetWitness = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/witnesses/",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const createAssetSuspect = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/suspects/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const createAssetReporter = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/reporters/",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

export const createAssetOwner = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/owners/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const createAssetEvidence = async (data: any) => {
  const response = await apiClient.post(
    "asset_recovery/evidences/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const fetchAssetReferralById = async (id: string) => {
  const response = await apiClient.get<Referral>(
    `asset_recovery/referrals/${id}/`
  );
  return response.data;
}

export const updateAssetReferral = async (id: string, data: any) => {
  const response = await apiClient.patch<Referral>(
    `asset_recovery/referrals/${id}/`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }

  )
  return response.data;
}

export const createAsset = async (data: Asset) => {
  const response = await apiClient.post<Asset>(
    "asset_recovery/assets/",
    data,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};


export const fetchPersonsListBYFaydaIdOrPhoneNumber = async ({ faydaId, phone }: { faydaId?: string, phone?: string }) => {
  const response = await apiClient.get<Person[]>(
    `asset_recovery/persons/search-by-phone-or-fayda/?phone=${phone}&fayda_number=${faydaId}`
  );
  return response.data;
}

export const addReferralDecision = async (data: any) => {
  const response = await apiClient.patch(
    `asset_recovery/referrals/${data.referral}/`,
    data.formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const addPerson = async (data: Person) => {
  const response = await apiClient.post<any>(
    "asset_recovery/persons/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export const fetchNotInCustodyReasons = async () => {
  const response = await apiClient.get(
    "base_data/asset-not-in-custody-reasons/"
  )
  return response.data
}

export const fetchVictimTypes = async () => {
  const response = await apiClient.get(
    "base_data/asset-victim-types/"
  )
  return response.data
}
export const fetchVicitmConditions = async () => {
  const response = await apiClient.get(
    "base_data/asset-victim-conditions/"
  )
  return response.data
}

export const fetchProsecutors = async (loginData: LoginAccount) => {
  console.log("fetchProsecutors called with loginData:", loginData);
  const access = loginData.access ?? ""
  const orgId = loginData.org_unit ?? "";
  const adminId = loginData.admin_unit ?? "";
  const response = await apiClient.get(`prosecutor-police/investigation-files/fetch-employees-by-org/?admin_id=${adminId}&org_id=${orgId}`, {
    headers: {
      Authorization: `Bearer ${access}`
    }
  })
  return response.data
}

export const updateAssetDecsion = async (id: string, prosecutor_decision_type: string | null) => {
  const response = await apiClient.patch<Referral>(
    `asset_recovery/assets/${id}/`,
    { prosecutor_decision_type },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }

  )
  return response.data;
}
export const updateAsset = async (id: string, data: any) => {
  const response = await apiClient.patch<Referral>(
    `asset_recovery/assets/${id}/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }

  )
  return response.data;
}
export const fetchAssetReferralByProsecutorId = async (loginData: LoginAccount) => {
  const user_id = loginData.user_id ?? "";
  const response = await apiClient.get<Referral[]>(
    `asset_recovery/referrals/by-prosecutor/?user_id=${user_id}`
  );
  return response.data;
}

export const addReferralRespondBack = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/asset-referral-feedbacks/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};
export const createFeedback = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/asset-referral-feedbacks/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};
export const getReferralRespondBacks = async () => {
  const response = await apiClient.get<ReferralRespondBack[]>(
    `asset_recovery/asset-referral-feedbacks/`,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

// API Service functions
export const deleteAssetOwner = async (id: string) => {
  const response = await apiClient.delete(`asset_recovery/owners/${id}/`);
  return response.data;
};

export const deleteAssetReporter = async (id: string) => {
  const response = await apiClient.delete(`asset_recovery/reporters/${id}/`);
  return response.data;
};

export const deleteAssetSuspect = async (id: string) => {
  const response = await apiClient.delete(`asset_recovery/suspects/${id}/`);
  return response.data;
};

export const deleteAssetVictim = async (id: string) => {
  const response = await apiClient.delete(`asset_recovery/victims/${id}/`);
  return response.data;
};

export const deleteAssetWitness = async (id: string) => {
  const response = await apiClient.delete(`asset_recovery/witnesses/${id}/`);
  return response.data;
};

export const deleteAssetEvidence = async (id: string) => {
  const response = await apiClient.delete(`asset_recovery/evidences/${id}/`);
  return response.data;
};

// services/assetRecoveryService.ts
export const updateAssetOwner = async (id: string, data: FormData) => {
  const response = await apiClient.patch(`asset_recovery/owners/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateAssetReporter = async (id: string, data: any) => {
  const response = await apiClient.patch(`asset_recovery/reporters/${id}/`, data);
  return response.data;
};

export const updateAssetSuspect = async (id: string, data: any) => {
  const response = await apiClient.patch(`asset_recovery/suspects/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateAssetVictim = async (id: string, data: any) => {
  const response = await apiClient.patch(`asset_recovery/victims/${id}/`, data);
  return response.data;
};

export const updateAssetWitness = async (id: string, data: any) => {
  const response = await apiClient.patch(`asset_recovery/witnesses/${id}/`, data);
  return response.data;
};

export const updateAssetEvidence = async (id: string, data: FormData) => {
  const response = await apiClient.patch(`asset_recovery/evidences/${id}/`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const updateAssetSeizureRestraint = async (id: string, data: any) => {
  const response = await apiClient.patch(
    `asset_recovery/asset-provisions/${id}/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
}
export const createAssetProvision = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/asset-provisions/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
}
export const addReport = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/asset-prohibition-reports/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};
export const addAssetRecoveryReport = async (data: any) => {
  const response = await apiClient.post(
    `asset_recovery/asset-recovery-final-verdicts/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response.data;
};

export const fetchAppointmentReasons = async () => {
  const response = await apiClient.get(
    "base_data/asset-appointment-court-types/"
  )
  return response.data
}

export const getReferralRespondBacksByReferralId = async (id: string) => {
  const response = await apiClient.get<ReferralRespondBack[]>(
    `asset_recovery/asset-referral-feedbacks/by-referral/?referral_id=${id}`,


  );
  return response.data;
};

export const getReferralReportsByReferralId = async (id: string) => {
  const response = await apiClient.get<Report[]>(
    `asset_recovery/asset-prohibition-reports/by-referral/?referral_id=${id}`,


  );
  return response.data;
};
export const getAssetRecoveryReportsByReferralId = async (id: string) => {
  const response = await apiClient.get<Report[]>(
    `asset_recovery/asset-recovery-final-verdicts/by-referral/?referral_id=${id}`,


  );
  return response.data;
};

export const getChildUserOrgDetails = async (adminUnitId: string, orgUnitId: string) => {
  const response = await apiClient.get(
    `appeal/appeal-requests/user-org-details/?admin_unit_uuid=${adminUnitId}&org_unit_uuid=${orgUnitId}`
  );
  return response.data;
};

// admin_unit_uuid=6ed63cf5-10b1-441d-bab6-3cb17ea5cb1c&org_unit_uuid=6c8b37c6-5295-4643-a251-a0be158198d0


export const fetchAssetReferralsByUnit = async (adminUnitId: string, orgUnitId: string) => {
  const response = await apiClient.get<Referral[]>(
    `asset_recovery/referrals/filter-by-unit/?admin_unit_id=${adminUnitId}&org_unit_id=${orgUnitId}`
  );
  return response.data;
}


export const fetchProsecutorDecisionTypesList = async () => {
  const response = await apiClient.get<{ id: string, name: string }[]>(
    "base_data/asset_prosecutor_decision_types/"
  );
  return response.data;
}

export const updateProhibitionReport = async (id: string, data: any) => {
  const response = await apiClient.patch(`asset_recovery/asset-prohibition-reports/${id}/`, data);
  return response.data;
};

export const updateRecoveryReport = async (id: string, data: any) => {
  const response = await apiClient.patch(`asset_recovery/asset-recovery-final-verdicts/${id}/`, data);
  return response.data;
};